import React, { Component } from "react";

export default class AddressImg extends Component {
  render() {
    // const theme = this.props.theme;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="890"
        height="729.787"
        data-name="Layer 1"
        viewBox="0 0 890 729.787"
      >
        <path
          fill="#2f2e41"
          d="M374.677 751.016l1.81 38.157v.001a24.345 24.345 0 01-23.163 25.47l-.79.037-2.964-62.474z"
          transform="translate(-155 -85.106)"
        ></path>
        <path
          fill="#e6e6e6"
          d="M917.171 686.534c-18.173 35.465-41.224 69.764-70.389 100.807-.648.701-1.302 1.384-1.962 2.08l-69.1-32.714c.422-.702.885-1.49 1.384-2.352 29.683-50.787 208.865-360.592 203.203-430.759.66 5.788 21.898 197.17-63.136 362.938z"
          transform="translate(-155 -85.106)"
        ></path>
        <path
          fill="#e6e6e6"
          d="M860.113 793.652a92.323 92.323 0 01-2.957 1.608l-51.838-24.54c.725-.514 1.57-1.122 2.54-1.806 15.88-11.403 63.105-45.613 109.313-82.38 49.658-39.511 98.152-81.965 105.354-102.229-1.463 4.647-46.914 145.897-162.412 209.347z"
          transform="translate(-155 -85.106)"
        ></path>
        <circle cx="86.23" cy="648.051" r="80" fill="#031f57"></circle>
        <path
          fill="#fff"
          d="M273.275 699.586h-64.09a10.694 10.694 0 00-10.682 10.681v45.78a10.694 10.694 0 0010.681 10.681h64.091a10.694 10.694 0 0010.682-10.682v-45.779a10.694 10.694 0 00-10.682-10.681zm0 6.104a4.559 4.559 0 011.134.147L241.237 732.3l-32.978-26.515a4.58 4.58 0 01.925-.094zm0 54.934h-64.09a4.583 4.583 0 01-4.579-4.578V710.68l34.711 27.908a3.052 3.052 0 003.816.008l34.72-27.697v45.148a4.583 4.583 0 01-4.578 4.578z"
          transform="translate(-155 -85.106)"
        ></path>
        <path
          fill="#ffb8b8"
          d="M549.968 617.658l17.9.147a12.454 12.454 0 0012.399-14.43 12.454 12.454 0 00-17.807-9.192l-16.88 8.33-57.737 12.876-24.735-25.29L448.9 613.5l33.378 25.788z"
          transform="translate(-155 -85.106)"
        ></path>
        <path
          fill="#2f2e41"
          d="M546.613 802.596l-21.09 4.056c-14.404-45.409-30.012-88.41-30.011-121.67-20.386 22.689-45.667 35.669-75.436 39.745l3.245-50.29 24.334-12.978 37.243-17.19a28.28 28.28 0 0110.365-2.563 28.28 28.28 0 0129.412 23.773z"
          transform="translate(-155 -85.106)"
        ></path>
        <path
          fill="#2f2e41"
          d="M445.627 718.644l-8.405 6.388a26.03 26.03 0 01-25.663 3.345c-24.075-18.046-41.179-12.722-56.681 14.517-18.594-20.986-23.182-51.295-6.587-82.652l92.064 2.028 18.656-5.678z"
          transform="translate(-155 -85.106)"
        ></path>
        <path
          fill="#2f2e41"
          d="M414.967 812.623a23.507 23.507 0 01-27.82-11.721c-8.274-7.287-15.255-17.72-21.31-30.409a235.353 235.353 0 01-11.167-28.683c-4.19-12.94 2.816-27.077 15.855-30.948q.582-.173 1.177-.326c17.407-4.468 35.282 5.571 41.232 22.528l17.3 49.309a23.507 23.507 0 01-14.398 29.964q-.432.151-.87.286z"
          transform="translate(-155 -85.106)"
        ></path>
        <path
          d="M362.891 764.878s20.279 22.712 24.334 35.69"
          opacity="0.2"
          transform="translate(-155 -85.106)"
          style={{ isolation: "isolate" }}
        ></path>
        <path
          fill="#ffb8b8"
          d="M284.244 657.693l-6.787 16.564a12.454 12.454 0 008.791 16.872 12.454 12.454 0 0015.15-13.117l-1.463-18.767 9.496-58.388 32.668-13.57-16.447-21.885-36.343 21.409z"
          transform="translate(-155 -85.106)"
        ></path>
        <path
          fill="#031f57"
          d="M446.438 660.242c-23.306 39.147-69.767 54.306-109.56 23.652 7-23 29.6-86.567 15-89-31 13-31.045-17.523-36.844-32.8l70.57-25.956 38.123 10.545 7.814 2.773a26.42 26.42 0 0117.583 24.537c-16.015 23.136-27.87 47.816-2.686 86.25z"
          transform="translate(-155 -85.106)"
        ></path>
        <path
          fill="#031f57"
          d="M455.36 628.608l-27.983-23.117 9.328-53.94 38.123 40.556z"
          transform="translate(-155 -85.106)"
        ></path>
        <path
          fill="#3f3d56"
          d="M919.705 258.051h-4V148.506a63.4 63.4 0 00-63.4-63.4H620.218a63.4 63.4 0 00-63.4 63.4V749.48a63.4 63.4 0 0063.4 63.4h232.085a63.4 63.4 0 0063.4-63.4V336.027h4z"
          data-name="b82a9922-ead1-40af-af3b-f133b244cde7"
          transform="translate(-155 -85.106)"
        ></path>
        <path
          fill="#fff"
          d="M854.862 101.6h-30.295a22.495 22.495 0 01-20.828 30.993H670.78a22.495 22.495 0 01-20.826-30.99h-28.3a47.348 47.348 0 00-47.348 47.347v600.09a47.348 47.348 0 0047.348 47.347h233.2a47.348 47.348 0 0047.348-47.348V148.947a47.348 47.348 0 00-47.348-47.348h.009z"
          data-name="b2a7827b-2d2c-407d-93be-35e4c67116bc"
          transform="translate(-155 -85.106)"
        ></path>
        <circle
          cx="583.658"
          cy="651.746"
          r="26"
          fill="#e6e6e6"
          data-name="e6b07811-3d0f-4972-ba4c-46b0c6566e33"
        ></circle>
        <path
          fill="#e6e6e6"
          d="M633.182 496.405c-2.457 0-4.457 2.282-4.457 5.087s2 5.088 4.457 5.088h210.143c2.457 0 4.457-2.282 4.457-5.088s-2-5.087-4.457-5.087zM633.182 616.405c-2.457 0-4.457 2.282-4.457 5.087s2 5.088 4.457 5.088h210.143c2.457 0 4.457-2.282 4.457-5.088s-2-5.087-4.457-5.087zM633.182 526.932c-2.457 0-4.457 2.283-4.457 5.088s2 5.088 4.457 5.088h90.425c2.458 0 4.458-2.283 4.458-5.088s-2-5.088-4.458-5.088zM633.182 556.03c-2.457 0-4.457 2.283-4.457 5.088s2 5.088 4.457 5.088h210.143c2.457 0 4.457-2.283 4.457-5.088s-2-5.088-4.457-5.088zM633.182 586.558c-2.457 0-4.457 2.282-4.457 5.088s2 5.088 4.457 5.088h90.425c2.458 0 4.458-2.283 4.458-5.088s-2-5.088-4.458-5.088z"
          transform="translate(-155 -85.106)"
        ></path>
        <path
          fill="#031f57"
          d="M672.853 264.733h130.814a5.457 5.457 0 015.45 5.451v136.237a5.457 5.457 0 01-5.45 5.45H672.853a5.457 5.457 0 01-5.45-5.45V270.184a5.457 5.457 0 015.45-5.45z"
          transform="translate(-155 -85.106)"
        ></path>
        <path
          fill="#fff"
          d="M775.793 383.777a3.7 3.7 0 10.004-7.4h-75.07a3.7 3.7 0 10-.004 7.4h75.07zM775.793 361.975a3.7 3.7 0 000-7.401h-75.066a3.7 3.7 0 10-.004 7.4h75.07zM738.26 292.828a23.293 23.293 0 11-23.293 23.293 23.319 23.319 0 0123.293-23.293z"
          transform="translate(-155 -85.106)"
        ></path>
        <path
          fill="#2f2e41"
          d="M441.064 529.077h-69.15a5.371 5.371 0 01-5.365-5.366v-29.805a39.94 39.94 0 1179.88 0v29.805a5.371 5.371 0 01-5.365 5.366z"
          transform="translate(-155 -85.106)"
        ></path>
        <circle
          cx="414.124"
          cy="497.999"
          r="29.283"
          fill="#ffb6b6"
          transform="rotate(-61.337 264.866 586.134)"
        ></circle>
        <path
          fill="#2f2e41"
          d="M455.878 496.886h-42.283l-.434-6.07-2.168 6.07h-6.51l-.86-12.032-4.297 12.032h-12.598v-.596a31.63 31.63 0 0131.594-31.594h5.962a31.63 31.63 0 0131.594 31.594z"
          transform="translate(-155 -85.106)"
        ></path>
        <path
          fill="#2f2e41"
          d="M413.248 534.64a5.481 5.481 0 01-.949-.083l-30.962-5.463v-51.171h34.083l-.844.984c-11.74 13.692-2.895 35.894 3.422 47.91a5.286 5.286 0 01-.42 5.611 5.344 5.344 0 01-4.33 2.212zM516.333 787.282l38.2-.002h.001a24.345 24.345 0 0124.344 24.344v.79l-62.544.003z"
          transform="translate(-155 -85.106)"
        ></path>
        <path
          fill="#cacaca"
          d="M1044 814.894H156a1 1 0 010-2h888a1 1 0 010 2z"
          transform="translate(-155 -85.106)"
        ></path>
      </svg>
    );
  }
}
